/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './DeepLinkRendererStyles.scss';
export function DeepLinkRenderer({ block }) {
    const dl = block;
    const handleOpen = useCallback(() => {
        // Validate URL to prevent XSS via javascript:, data:, etc.
        try {
            // Allow relative paths starting with / or #
            if (dl.url.startsWith('/') || dl.url.startsWith('#')) {
                window.open(dl.url, '_blank', 'noopener,noreferrer');
                return;
            }
            // Parse absolute URLs and validate protocol
            const parsedUrl = new URL(dl.url);
            const safeProtocols = ['http:', 'https:'];
            if (safeProtocols.includes(parsedUrl.protocol)) {
                window.open(dl.url, '_blank', 'noopener,noreferrer');
            }
            // Silently reject unsafe schemes (javascript:, data:, file:, blob:, etc.)
        }
        catch (_a) {
            // Invalid URL - do not open
        }
    }, [dl.url]);
    return (React.createElement(AIGeneralBlockCard, { sections: [
            {
                label: dl.resource_type,
                content: React.createElement(Text, { variant: "body" }, dl.label),
                copyText: dl.label
            }
        ], footerGroups: [
            {
                actions: [
                    {
                        id: 'open',
                        label: 'Open',
                        icon: dl.icon || 'fa-light fa-arrow-up-right-from-square',
                        onClick: handleOpen
                    }
                ]
            }
        ] }));
}
